var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cte"}},[_c('CteTopBar',{attrs:{"title":'Industry Sectors'}}),_c('div',{staticClass:"page"},[(_vm.loadingSectors)?_c('div',{staticClass:"loading-circles"},[_c('span'),_c('span'),_c('span')]):_vm._e(),_c('CteSectors')],1),_c('add-sector-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }